// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ng-valid[required], .ng-valid.required  {
  border: 1px solid #3c763d;
}
.ng-touched.ng-invalid:not(form)  {
  border:1px solid #a94442;
}
.report-tab-content .form-group {
  padding-bottom: 25px;
  margin-bottom: 0px;
}
.text-danger{
  position: absolute;
  width: 94%;
}
.text-center{
  text-align: center !important;
}
#mySetting .modal-body{
  max-height: 350px;
  overflow-y: scroll;
}

.numberCircle {

border-radius:50%;
width:40px;
height:40px;
display:block;
float:left;
border:2px solid #000000;
color:#000000;
text-align:center;
margin-right:5px;
}
#cancel{
      color: #fff;
    background-color: #9A0A35;
    border-color: #122b40
}

.outer-setting{width: 27px;height: 27px;float: right;background: #fff;border-radius: 50%;cursor: pointer;}
.outer-setting span{position: relative;right: 4px;top: 4px;color: #00A6C6}
.rdesc{padding-top: 0;margin-top: -2px}
.btn-circle {
  width: 30px;
  height: 30px;
  text-align: center;
  padding: 6px 0;
  font-size: 12px;
  line-height: 1.428571429;
  border-radius: 15px;
}
.bus-name .btn-primary {
border-color: #949599;
position: relative;
top: 34px;
left: -11px;    background-color: #fff;
}
.bg-white .glyphicon {

color: #949599;
}
.client-name {
  color: #d6104c;
  font-weight: bold;
  width: 135px;
  float: right;
}
.client-name span {
  float: left;
  font-size: 13px;
  width: 100%;
  font-weight: normal;
  color: #949599;
}
.btn-gray {
  background-color: #999!important;
}

button#generateoutput {
    width: 14%;
}
.cncl-btn{FLOAT: RIGHT;
  background: #2184be;
  border-radius: 18px;
  COLOR: #FFF;}
  .cncl-btn a{color: #fff !important;    text-decoration: none;}
button#btnsave {
    /* color: pink; */
        color: #fff;
    background-color: #9A0A35;
    border-color: #122b40;
}
.navbar-nav>li>a{
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
  font-size: 13px;
  margin-left: -7px;
}
.nav>li>a>img {
  max-width: none;
  width: 32px;
  margin-right: 0px;
  margin-bottom: 3px;

}

.form-control{
  position:relative !important;
}

.btn-outer{
  display: flex;
  align-items: center;
  justify-content: center;

}
.btn-outer span{
  position: relative;
  border: 0px;
  background: transparent;
  overflow: hidden;
  padding: 0;
  margin: 0

}

button#generateoutput {
  width: auto;
}

`, "",{"version":3,"sources":["webpack://./src/app/create-report/create-report.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;AAEA,iBAAiB;AACjB,UAAU;AACV,WAAW;AACX,aAAa;AACb,UAAU;AACV,wBAAwB;AACxB,aAAa;AACb,iBAAiB;AACjB,gBAAgB;AAChB;AACA;MACM,WAAW;IACb,yBAAyB;IACzB;AACJ;;AAEA,eAAe,WAAW,CAAC,YAAY,CAAC,YAAY,CAAC,gBAAgB,CAAC,kBAAkB,CAAC,eAAe,CAAC;AACzG,oBAAoB,kBAAkB,CAAC,UAAU,CAAC,QAAQ,CAAC,cAAc;AACzE,OAAO,cAAc,CAAC,gBAAgB;AACtC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;AACA;AACA,qBAAqB;AACrB,kBAAkB;AAClB,SAAS;AACT,WAAW,KAAK,sBAAsB;AACtC;AACA;;AAEA,cAAc;AACd;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;;AAEA;IACI,UAAU;AACd;AACA,UAAU,YAAY;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW,CAAC;EACZ,YAAY,sBAAsB,KAAK,qBAAqB,CAAC;AAC/D;IACI,iBAAiB;QACb,WAAW;IACf,yBAAyB;IACzB,qBAAqB;AACzB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;;AAEpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;AAEzB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV;;AAEF;;AAEA;EACE,WAAW;AACb","sourcesContent":[".ng-valid[required], .ng-valid.required  {\r\n  border: 1px solid #3c763d;\r\n}\r\n.ng-touched.ng-invalid:not(form)  {\r\n  border:1px solid #a94442;\r\n}\r\n.report-tab-content .form-group {\r\n  padding-bottom: 25px;\r\n  margin-bottom: 0px;\r\n}\r\n.text-danger{\r\n  position: absolute;\r\n  width: 94%;\r\n}\r\n.text-center{\r\n  text-align: center !important;\r\n}\r\n#mySetting .modal-body{\r\n  max-height: 350px;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.numberCircle {\r\n\r\nborder-radius:50%;\r\nwidth:40px;\r\nheight:40px;\r\ndisplay:block;\r\nfloat:left;\r\nborder:2px solid #000000;\r\ncolor:#000000;\r\ntext-align:center;\r\nmargin-right:5px;\r\n}\r\n#cancel{\r\n      color: #fff;\r\n    background-color: #9A0A35;\r\n    border-color: #122b40\r\n}\r\n\r\n.outer-setting{width: 27px;height: 27px;float: right;background: #fff;border-radius: 50%;cursor: pointer;}\r\n.outer-setting span{position: relative;right: 4px;top: 4px;color: #00A6C6}\r\n.rdesc{padding-top: 0;margin-top: -2px}\r\n.btn-circle {\r\n  width: 30px;\r\n  height: 30px;\r\n  text-align: center;\r\n  padding: 6px 0;\r\n  font-size: 12px;\r\n  line-height: 1.428571429;\r\n  border-radius: 15px;\r\n}\r\n.bus-name .btn-primary {\r\nborder-color: #949599;\r\nposition: relative;\r\ntop: 34px;\r\nleft: -11px;    background-color: #fff;\r\n}\r\n.bg-white .glyphicon {\r\n\r\ncolor: #949599;\r\n}\r\n.client-name {\r\n  color: #d6104c;\r\n  font-weight: bold;\r\n  width: 135px;\r\n  float: right;\r\n}\r\n.client-name span {\r\n  float: left;\r\n  font-size: 13px;\r\n  width: 100%;\r\n  font-weight: normal;\r\n  color: #949599;\r\n}\r\n.btn-gray {\r\n  background-color: #999!important;\r\n}\r\n\r\nbutton#generateoutput {\r\n    width: 14%;\r\n}\r\n.cncl-btn{FLOAT: RIGHT;\r\n  background: #2184be;\r\n  border-radius: 18px;\r\n  COLOR: #FFF;}\r\n  .cncl-btn a{color: #fff !important;    text-decoration: none;}\r\nbutton#btnsave {\r\n    /* color: pink; */\r\n        color: #fff;\r\n    background-color: #9A0A35;\r\n    border-color: #122b40;\r\n}\r\n.navbar-nav>li>a{\r\n  padding-top: 0px;\r\n  padding-bottom: 0px;\r\n  padding-left: 0px;\r\n  font-size: 13px;\r\n  margin-left: -7px;\r\n}\r\n.nav>li>a>img {\r\n  max-width: none;\r\n  width: 32px;\r\n  margin-right: 0px;\r\n  margin-bottom: 3px;\r\n\r\n}\r\n\r\n.form-control{\r\n  position:relative !important;\r\n}\r\n\r\n.btn-outer{\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n}\r\n.btn-outer span{\r\n  position: relative;\r\n  border: 0px;\r\n  background: transparent;\r\n  overflow: hidden;\r\n  padding: 0;\r\n  margin: 0\r\n\r\n}\r\n\r\nbutton#generateoutput {\r\n  width: auto;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
